import { commonLang } from '@umu/ukit-lang';
import './tipsDialog.scss';
import React from 'react';
import { components } from 'common';
const { If } = components;
export interface IProps {
    closeDialog: () => void;
    title?: string;
    content: string;
    showConfirm?: boolean;
    showCancel?: boolean;
    confirmClick?: () => void;
    confirmText?: string;
    cancelClick?: () => void;
    cancelText?: string;
}

function TipsDialog(props: IProps) {
    const { content, title, confirmText, cancelText, showConfirm, showCancel } = props;
    const closeDialog = () => {
        props.closeDialog();

        const $dialogMaskEle = document.querySelector('.dialog-mask');
        if ($dialogMaskEle) {
            $dialogMaskEle.parentNode?.removeChild($dialogMaskEle);
        }
    };
    const onClose = () => {
        closeDialog();
        if (props.cancelClick) {
            props.cancelClick();
        }
    };
    const submit = () => {
        closeDialog();
        if (props.confirmClick) {
            props.confirmClick();
        }
    };
    return (
        <div className="learning-map-tips-dialog">
            <If condition={!!title}>
                <div className="tips-dialog-title">
                    <div>{title}</div>
                </div>
            </If>
            <If condition={!!content}>
                <div className="tips-dialog-content">
                    <div>{content}</div>
                </div>
            </If>
            <div className="tips-dialog-footer">
                <If condition={!!showCancel}>
                    <div className="dialog-btn btn-cancel" onClick={onClose}>
                        {cancelText || commonLang('取消')}
                    </div>
                </If>
                <If condition={!!showConfirm}>
                    <div className="dialog-btn btn-confirm" onClick={submit}>
                        {confirmText || commonLang('确定')}
                    </div>
                </If>
            </div>
        </div>
    );
}

export default TipsDialog;